/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import { Loading } from "@/shared/presentation/components/loading";
import { CookieContext } from "@/shared/presentation/context-api/providers/cookie";
export var SaveAuthCookieContainer = function () {
    var saveToken = useContext(CookieContext).saveToken;
    useEffect(function () {
        saveToken();
    }, []);
    return React.createElement(Loading, null);
};
